import { Position } from 'react-rnd'
import { MouseEventWithView } from 'src/types'

export const getPositionWithScroll = (event: MouseEventWithView, position: Position): Position => {
  return { x: position.x + (event.view.scrollX || 0), y: position.y + (event.view.scrollY || 0) }
}
